module.exports = __webpack_public_path__ + "img/conflux_logo.05e8dadd.png";